jQuery(document).ready(function ($) {
  const lmPage = "lead-market";
  const lmDetailsName = "lmDetails";
  const lmThankYouPage = "lead-market-thank-you";
  initLM();
  initLMThankYou();

  function initLM() {
    var lmToken = getParamFromURL("token");

    if (lmToken && getCurrentPagePath().toLowerCase().indexOf(lmPage) !== -1) {
      saveLMTokenInLocalStorage(lmToken);
    }
  }

  function initLMThankYou() {
    if (getCurrentPagePath().toLowerCase().indexOf(lmThankYouPage) !== -1) {
      var lmDetails = JSON.parse(localStorage.getItem(lmDetailsName));
      if (lmDetails.token) {
        var data = {
          action: "submit_lm_lead",
          lm_token: lmDetails.token,
          campaignDetails: fetchCampaignDetails(),
          campaignIds: fetchCampaignIds(),
        };
        $.ajax({
          data: data,
          type: "post",
          url: mb_theme_envs.ajax_url,

          success: function () {
            console.log("LM - success NE lead");
            window.location.replace("/thank-you");
          },
          error: function () {
            console.log("LM - failed NE lead");
            window.location.replace("/enquire-online");
          },
        });
      } else {
        console.log("LM - No Token");
        window.location.replace("/enquire-online");
      }
    }
  }
  function fetchCampaignIds() {
    return localStorage.getItem("campaignIds");
  }
  function fetchCampaignDetails() {
    var campaignDetails = JSON.parse(localStorage.getItem("campaignDetails"));
    campaignDetails.url =
      document.location.protocol +
      "//" +
      document.location.host +
      "/lead-market";
    campaignDetails.source = "LEADMARKET";
    return JSON.stringify(campaignDetails);
  }
  function saveLMTokenInLocalStorage(lmToken) {
    var lmDetailsStorage = { token: lmToken };

    localStorage.setItem(lmDetailsName, JSON.stringify(lmDetailsStorage));
  }
  function getParamFromURL(param) {
    const paramLower = param;
    const paramUpper = param.toUpperCase();
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      // IE 11 support
      const params = {};
      window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (_, key, value) {
          return (params[key] = value);
        }
      );

      return params[paramLower]
        ? decodeURIComponent(params[paramLower])
        : params[paramUpper]
          ? decodeURIComponent(params[paramUpper])
          : "";
    } else {
      const params = new URL(document.location).searchParams;
      // Params are case sensitive
      return params.get(paramLower)
        ? decodeURIComponent(params.get(paramLower))
        : params.get(paramUpper)
          ? decodeURIComponent(params.get(paramUpper))
          : "";
    }
  }
  function getCurrentPagePath() {
    var currentPath = window.location.pathname;
    return currentPath.replace(/\\|\//g, "");
  }
});
